import { Component, inject, input, model, output, ViewEncapsulation } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Store } from '@ngrx/store';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';

export enum SearchBoxType {
    OPEN = 'open',
    EXPANDABLE = 'expandable',
}

export enum SuggestionType {
    STAFF = 'staff',
    TAG = 'tag',
}
export type SuggestionItem = {
    value: string;
    label: string;
    type?: SuggestionType;
};

@Component({
    selector: 'st-simple-search-box',
    templateUrl: './simple-search-box.html',
    styleUrls: ['./simple-search-box.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-simple-search-box',
    },
})
export class SimpleSearchBoxComponent {
    SuggestionType = SuggestionType;

    // injectables
    store = inject(Store);

    // selectors
    languageSettings = this.store.selectSignal(selectI18N);

    // inputs
    type = input<SearchBoxType>(SearchBoxType.EXPANDABLE);
    suggestions = input<SuggestionItem[]>([]);

    // ouputs
    changed = output<string>();
    searchExecuted = output<string>();

    // local signals
    searchTherm = model('');

    // local methods
    searchChanged() {
        this.changed.emit(this.searchTherm());
    }

    executeSearch() {
        this.searchChanged();
        this.searchExecuted.emit(this.searchTherm());
    }

    clearSearch() {
        this.searchTherm.set('');
    }

    selectSuggestion(event: MatAutocompleteSelectedEvent) {
        const id = event?.option?.value;
        const val = this.suggestions().find(item => item.value === id);
        if (val.type === SuggestionType.TAG) {
            this.searchTherm.set(`#${val.value.trim()}`);
        } else if (val.type === SuggestionType.STAFF) {
            this.searchTherm.set(`@${val.value.trim()}`);
        } else {
            this.searchTherm.set(id.trim());
        }
        this.executeSearch();
    }

    getUserId(item: SuggestionItem): string {
        return item.value;
    }
}
